import React from "react";
import { Text, Box, Group, Tooltip, Sx } from "@mantine/core";

export const InfoTooltip: React.FC<{
  label: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  sx?: Sx;
  textSx?: Sx;
}> = ({ label, icon, children, sx, textSx }) => (
  <Tooltip label={label}>
    <Group
      noWrap
      spacing={3}
      h="32px"
      px="sm"
      py={0}
      align="center"
      sx={{
        cursor: "default",
        borderRadius: "5px",
        background: "#F8F9FB",
        alignContent: "center",
        minWidth: 0,
        ...sx,
      }}
    >
      {icon && <Box pt={5} mr={5}>{icon}</Box>}
      <Text fz="14px" sx={{ minWidth: 0, ...textSx }}>
        {children}
      </Text>
    </Group>
  </Tooltip>
);
